export default {
  modelName: 'Dodoable',
  attributes: {
    abbr: {
      name: "abbr",
      apiName: "abbr",
      camelName: "abbr",
      underscoreName: "abbr",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Abbr",
    },
    aboutTime: {
      name: "aboutTime",
      apiName: "aboutTime",
      camelName: "aboutTime",
      underscoreName: "about_time",
      type: "string",
      writeable: true,
      default: "track",
      humanName: "About Time",
    },
    active: {
      name: "active",
      apiName: "active",
      camelName: "active",
      underscoreName: "active",
      type: "boolean",
      writeable: true,
      default: true,
      humanName: "Active",
    },
    ancestry: {
      name: "ancestry",
      apiName: "ancestry",
      camelName: "ancestry",
      underscoreName: "ancestry",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Ancestry",
    },
    createdAt: {
      name: "createdAt",
      apiName: "createdAt",
      camelName: "createdAt",
      underscoreName: "created_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Created At",
    },
    currentable: {
      name: "currentable",
      apiName: "currentable",
      camelName: "currentable",
      underscoreName: "currentable",
      type: "jsonb",
      writeable: true,
      default: "true",
      humanName: "Currentable",
    },
    dodones: {
      name: "dodones",
      apiName: "dodones",
      camelName: "dodones",
      underscoreName: "dodones",
      type: "has_many",
      writeable: true,
      default: null,
      humanName: "Dodones",
      model: "Dodone",
    },
    fields: {
      name: "fields",
      apiName: "fields",
      camelName: "fields",
      underscoreName: "fields",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Fields",
    },
    freeable: {
      name: "freeable",
      apiName: "freeable",
      camelName: "freeable",
      underscoreName: "freeable",
      type: "boolean",
      writeable: true,
      default: false,
      humanName: "Freeable",
    },
    googleDriveFolderId: {
      name: "googleDriveFolderId",
      apiName: "googleDriveFolderId",
      camelName: "googleDriveFolderId",
      underscoreName: "google_drive_folder_id",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Google Drive Folder",
    },
    icon: {
      name: "icon",
      apiName: "icon",
      camelName: "icon",
      underscoreName: "icon",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Icon",
    },
    id: {
      name: "id",
      apiName: "id",
      camelName: "id",
      underscoreName: "id",
      type: "integer",
      writeable: false,
      default: null,
      humanName: "Id",
    },
    name: {
      name: "name",
      apiName: "name",
      camelName: "name",
      underscoreName: "name",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Name",
    },
    resolverAttributes: {
      name: "resolverAttributes",
      apiName: "resolverAttributes",
      camelName: "resolverAttributes",
      underscoreName: "resolver_attributes",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Resolver Attributes",
    },
    settings: {
      name: "settings",
      apiName: "settings",
      camelName: "settings",
      underscoreName: "settings",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Settings",
    },
    slug: {
      name: "slug",
      apiName: "slug",
      camelName: "slug",
      underscoreName: "slug",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Slug",
    },
    type: {
      name: "type",
      apiName: "type",
      camelName: "type",
      underscoreName: "type",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Type",
    },
    typeViewPrefix: {
      name: "typeViewPrefix",
      apiName: "typeViewPrefix",
      camelName: "typeViewPrefix",
      underscoreName: "type_view_prefix",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Type View Prefix",
    },
    updatedAt: {
      name: "updatedAt",
      apiName: "updatedAt",
      camelName: "updatedAt",
      underscoreName: "updated_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Updated At",
    },
    user: {
      name: "user",
      apiName: "user",
      camelName: "user",
      underscoreName: "user",
      type: "belongs_to",
      writeable: true,
      default: null,
      humanName: "User",
      model: "User",
    },
    userId: {
      name: "userId",
      apiName: "userId",
      camelName: "userId",
      underscoreName: "user_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "User",
    },
  },
  names: {
    model: "Dodoable",
    base: "dodoable",
    baseSingularClass: "Dodoable",
    human: "Dodoable",
    singularCamelFull: "dodoable",
    singularCamel: "dodoable",
    singularClassFull: "Dodoable",
    singularClass: "Dodoable",
    singularDash: "dodoable",
    singularUnderscoreFull: "dodoable",
    singularUnderscore: "dodoable",
    singularUnderscorePath: "dodoable",
    pluralModel: "Dodoables",
    pluralCamelFull: "dodoables",
    pluralCamel: "dodoables",
    pluralClass: "Dodoables",
    pluralDash: "dodoables",
    pluralUnderscoreFull: "dodoables",
    pluralUnderscore: "dodoables",
    pluralUnderscorePath: "dodoables",
  },
  validators: [
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "user",
      ],
    },
  ],
  enums: {
    aboutTime: {
      name: "aboutTime",
      valueMap: {
        track: 0,
        timer: 1,
        instant: 2,
      },
      options: {
        track: 0,
        timer: 1,
        instant: 2,
      },
      settings: {
      },
    },
  },
}
